// # Designer routes configuration
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from '../ProtectedRoute';

// # Import designer components
import DesignerDashboard from '../../roles/employees/designer/designer_dashboard';

// # Import shared components
import Profile from '../../general/profile/profile';
import Settings from '../../general/gen_pages/settings';

// # Designer routes component
const DesignerRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={
        <ProtectedRoute requiredRole="designer">
          <DesignerDashboard />
        </ProtectedRoute>
      } />
      <Route path="/profile" element={
        <ProtectedRoute requiredRole="designer">
          <Profile />
        </ProtectedRoute>
      } />
      <Route path="/settings" element={
        <ProtectedRoute requiredRole="designer">
          <Settings />
        </ProtectedRoute>
      } />
    </Routes>
  );
};

export default DesignerRoutes; 